"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.websocketMessageReceived = exports.websocketMessageProceedError = exports.websocketClosed = exports.usageAnalyticsSendMessage = exports.usageAnalyticsOpenSuccess = exports.usageAnalyticsOpenPending = exports.updateSagaContext = exports.updateNotificationSuccess = exports.updateNotificationPending = exports.updateNotificationError = exports.toggleMenu = exports.toggleLifetimeModal = exports.toggleIdleModal = exports.showToast = exports.showNotificationsWidget = exports.showBurgerMenu = exports.setToast = exports.setSnack = exports.setLogoutTimer = exports.setLifetimeTimer = exports.setInactivityTimer = exports.readAllNotificationsSuccess = exports.prolongSession = exports.logout = exports.initAppFrame = exports.hideNotificationsWidget = exports.heapLoadSuccess = exports.heapLoadError = exports.getSessionSuccess = exports.getSessionPending = exports.getNotificationsSuccess = exports.getNotificationsPending = exports.getNotificationsError = exports.getMenuDataSuccess = exports.getMenuDataPending = exports.getMenuDataError = exports.getAppconfigSuccess = exports.getAppconfigPending = exports.getAppconfigError = exports.dynatraceLoadSuccess = exports.dynatraceLoadError = exports.createSessionPending = exports.closeUsageAnalytics = exports.clearToast = exports.clearSnack = exports.WS_OPEN_SUCCESS = exports.WS_OPEN_PENDING = exports.WS_OPEN_FAIL = exports.WS_NEW_NOTIFICATION = exports.WS_MSG_SEND = exports.WS_MSG_RECEIVED = exports.WS_MSG_PROCEED_ERROR = exports.WS_CLOSED = exports.UPDATE_SAGA_CONTEXT = exports.UPDATE_NOTIFICATION_SUCCESS = exports.UPDATE_NOTIFICATION_PENDING = exports.UPDATE_NOTIFICATION_FAIL = exports.UA_OPEN_SUCCESS = exports.UA_OPEN_PENDING = exports.UA_MSG_SEND = exports.UA_CLOSED = exports.TRACK_USER_IDENTITY = exports.TOGGLE_LIFETIME_MODAL = exports.TOGGLE_IDLE_MODAL = exports.SHOW_TOAST = exports.SHOW_NOTIFICATION_WIDGET = exports.SHOW_BURGER_MENU = exports.SET_TOAST = exports.SET_SNACK = exports.SET_LOGOUT_TIMER = exports.SET_LIFETIME_TIMER = exports.SET_INACTIVITY_TIMER = exports.READ_ALL_NOTIFICATIONS_SUCCESS = exports.PROLONG_SESSION = exports.MENU_TOGGLE = exports.LOGOUT = exports.INIT_APPFRAME = exports.HIDE_NOTIFICATION_WIDGET = exports.HEAP_LOAD_SUCCESS = exports.HEAP_LOAD_RESULT = exports.HEAP_LOAD_ERROR = exports.GET_SESSION_SUCCESS = exports.GET_SESSION_PENDING = exports.GET_NOTIFICATIONS_SUCCESS = exports.GET_NOTIFICATIONS_PENDING = exports.GET_NOTIFICATIONS_FAIL = exports.GET_MENU_DATA_SUCCESS = exports.GET_MENU_DATA_PENDING = exports.GET_MENU_DATA_ERROR = exports.GET_APP_CONFIG_SUCCESS = exports.GET_APP_CONFIG_RESULT = exports.GET_APP_CONFIG_PENDING = exports.GET_APP_CONFIG_ERROR = exports.DYNATRACE_LOAD_SUCCESS = exports.DYNATRACE_LOAD_RESULT = exports.DYNATRACE_LOAD_ERROR = exports.CREATE_SESSION_PENDING = exports.CLEAR_TOAST = exports.CLEAR_SNACK = exports.CHANGE_SNACK = void 0;
exports.websocketOpenSuccess = exports.websocketOpenPending = exports.websocketOpenError = exports.websocketNewNotification = exports.websocketMessageSend = void 0;
var _browser = require("../../components/utils/browser");
const GET_APP_CONFIG_PENDING = exports.GET_APP_CONFIG_PENDING = 'GET_APP_CONFIG_PENDING';
const GET_APP_CONFIG_SUCCESS = exports.GET_APP_CONFIG_SUCCESS = 'GET_APP_CONFIG_SUCCESS';
const GET_APP_CONFIG_ERROR = exports.GET_APP_CONFIG_ERROR = 'GET_APP_CONFIG_ERROR';
const getAppconfigPending = () => ({
  type: GET_APP_CONFIG_PENDING
});
exports.getAppconfigPending = getAppconfigPending;
const getAppconfigSuccess = config => ({
  type: GET_APP_CONFIG_SUCCESS,
  payload: {
    config
  }
});
exports.getAppconfigSuccess = getAppconfigSuccess;
const getAppconfigError = error => ({
  type: GET_APP_CONFIG_ERROR,
  payload: {
    error
  }
});
exports.getAppconfigError = getAppconfigError;
const SHOW_NOTIFICATION_WIDGET = exports.SHOW_NOTIFICATION_WIDGET = 'SHOW_NOTIFICATION_WIDGET';
const HIDE_NOTIFICATION_WIDGET = exports.HIDE_NOTIFICATION_WIDGET = 'HIDE_NOTIFICATION_WIDGET';
const showNotificationsWidget = () => ({
  type: SHOW_NOTIFICATION_WIDGET
});
exports.showNotificationsWidget = showNotificationsWidget;
const hideNotificationsWidget = () => ({
  type: HIDE_NOTIFICATION_WIDGET
});
exports.hideNotificationsWidget = hideNotificationsWidget;
const GET_NOTIFICATIONS_PENDING = exports.GET_NOTIFICATIONS_PENDING = 'GET_NOTIFICATIONS_PENDING';
const GET_NOTIFICATIONS_SUCCESS = exports.GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
const GET_NOTIFICATIONS_FAIL = exports.GET_NOTIFICATIONS_FAIL = 'GET_NOTIFICATIONS_FAIL';
const getNotificationsPending = () => ({
  type: GET_NOTIFICATIONS_PENDING
});
exports.getNotificationsPending = getNotificationsPending;
const getNotificationsSuccess = (nextPageToken, notifications) => ({
  type: GET_NOTIFICATIONS_SUCCESS,
  payload: {
    nextPageToken,
    notifications
  }
});
exports.getNotificationsSuccess = getNotificationsSuccess;
const getNotificationsError = error => ({
  type: GET_NOTIFICATIONS_FAIL,
  payload: {
    error
  }
});
exports.getNotificationsError = getNotificationsError;
const UPDATE_NOTIFICATION_PENDING = exports.UPDATE_NOTIFICATION_PENDING = 'UPDATE_NOTIFICATION_PENDING';
const UPDATE_NOTIFICATION_SUCCESS = exports.UPDATE_NOTIFICATION_SUCCESS = 'UPDATE_NOTIFICATION_SUCCESS';
const UPDATE_NOTIFICATION_FAIL = exports.UPDATE_NOTIFICATION_FAIL = 'UPDATE_NOTIFICATION_FAIL';
const updateNotificationPending = (notification, conflictMsg, callback) => ({
  type: UPDATE_NOTIFICATION_PENDING,
  payload: {
    notification,
    conflictMsg
  },
  meta: callback
});
exports.updateNotificationPending = updateNotificationPending;
const updateNotificationSuccess = id => ({
  type: UPDATE_NOTIFICATION_SUCCESS,
  payload: id
});
exports.updateNotificationSuccess = updateNotificationSuccess;
const updateNotificationError = error => ({
  type: UPDATE_NOTIFICATION_FAIL,
  payload: {
    error
  }
});
exports.updateNotificationError = updateNotificationError;
const READ_ALL_NOTIFICATIONS_SUCCESS = exports.READ_ALL_NOTIFICATIONS_SUCCESS = 'READ_ALL_NOTIFICATIONS_SUCCESS';
const readAllNotificationsSuccess = () => ({
  type: READ_ALL_NOTIFICATIONS_SUCCESS
});
exports.readAllNotificationsSuccess = readAllNotificationsSuccess;
const MENU_TOGGLE = exports.MENU_TOGGLE = 'MENU_TOGGLE';
const toggleMenu = isExpanded => ({
  type: MENU_TOGGLE,
  payload: isExpanded
});
exports.toggleMenu = toggleMenu;
const GET_MENU_DATA_PENDING = exports.GET_MENU_DATA_PENDING = 'GET_MENU_DATA_PENDING';
const GET_MENU_DATA_SUCCESS = exports.GET_MENU_DATA_SUCCESS = 'GET_MENU_DATA_SUCCESS';
const GET_MENU_DATA_ERROR = exports.GET_MENU_DATA_ERROR = 'GET_MENU_DATA_ERROR';
const getMenuDataPending = () => ({
  type: GET_MENU_DATA_PENDING
});
exports.getMenuDataPending = getMenuDataPending;
const getMenuDataSuccess = (sitemap, options) => ({
  type: GET_MENU_DATA_SUCCESS,
  payload: {
    sitemap,
    options
  }
});
exports.getMenuDataSuccess = getMenuDataSuccess;
const getMenuDataError = error => ({
  type: GET_MENU_DATA_ERROR,
  payload: {
    error
  }
});
exports.getMenuDataError = getMenuDataError;
const INIT_APPFRAME = exports.INIT_APPFRAME = 'INIT_APPFRAME';
const initAppFrame = payload => ({
  type: INIT_APPFRAME,
  payload
});
exports.initAppFrame = initAppFrame;
const CREATE_SESSION_PENDING = exports.CREATE_SESSION_PENDING = 'CREATE_SESSION_PENDING';
const GET_SESSION_PENDING = exports.GET_SESSION_PENDING = 'GET_SESSION_PENDING';
const GET_SESSION_SUCCESS = exports.GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS';
const createSessionPending = token => ({
  type: CREATE_SESSION_PENDING,
  payload: {
    token
  }
});
exports.createSessionPending = createSessionPending;
const getSessionPending = () => ({
  type: GET_SESSION_PENDING
});
exports.getSessionPending = getSessionPending;
const getSessionSuccess = session => ({
  type: GET_SESSION_SUCCESS,
  payload: session
});
exports.getSessionSuccess = getSessionSuccess;
const LOGOUT = exports.LOGOUT = 'LOGOUT';
const logout = (endpointURL, method, options) => ({
  type: LOGOUT,
  payload: {
    url: endpointURL,
    method,
    options
  }
});
exports.logout = logout;
const PROLONG_SESSION = exports.PROLONG_SESSION = 'PROLONG_SESSION';
const prolongSession = (isIdle = true) => ({
  type: PROLONG_SESSION,
  payload: isIdle
});
exports.prolongSession = prolongSession;
const SET_INACTIVITY_TIMER = exports.SET_INACTIVITY_TIMER = 'SET_INACTIVITY_TIMER';
const SET_LIFETIME_TIMER = exports.SET_LIFETIME_TIMER = 'SET_LIFETIME_TIMER';
const SET_LOGOUT_TIMER = exports.SET_LOGOUT_TIMER = 'SET_LOGOUT_TIMER';
const setInactivityTimer = (expirationTime, currentTime, modalDuration) => ({
  type: SET_INACTIVITY_TIMER,
  payload: {
    expirationTime,
    currentTime,
    modalDuration
  }
});
exports.setInactivityTimer = setInactivityTimer;
const setLifetimeTimer = (expirationTime, currentTime, modalDuration) => ({
  type: SET_LIFETIME_TIMER,
  payload: {
    expirationTime,
    currentTime,
    modalDuration
  }
});
exports.setLifetimeTimer = setLifetimeTimer;
const setLogoutTimer = modalDuration => ({
  type: SET_LOGOUT_TIMER,
  payload: {
    modalDuration
  }
});
exports.setLogoutTimer = setLogoutTimer;
const TOGGLE_IDLE_MODAL = exports.TOGGLE_IDLE_MODAL = 'TOGGLE_IDLE_MODAL';
const TOGGLE_LIFETIME_MODAL = exports.TOGGLE_LIFETIME_MODAL = 'TOGGLE_LIFETIME_MODAL';
const toggleIdleModal = open => ({
  type: TOGGLE_IDLE_MODAL,
  payload: open
});
exports.toggleIdleModal = toggleIdleModal;
const toggleLifetimeModal = open => ({
  type: TOGGLE_LIFETIME_MODAL,
  payload: open
});
exports.toggleLifetimeModal = toggleLifetimeModal;
const WS_OPEN_PENDING = exports.WS_OPEN_PENDING = 'WS_OPEN_PENDING';
const WS_OPEN_SUCCESS = exports.WS_OPEN_SUCCESS = 'WS_OPEN_SUCCESS';
const WS_OPEN_FAIL = exports.WS_OPEN_FAIL = 'WS_OPEN_FAIL';
const websocketOpenPending = (hostname, protocol, path) => ({
  type: WS_OPEN_PENDING,
  payload: {
    hostname,
    protocol,
    path
  }
});
exports.websocketOpenPending = websocketOpenPending;
const websocketOpenSuccess = () => ({
  type: WS_OPEN_SUCCESS
});
exports.websocketOpenSuccess = websocketOpenSuccess;
const websocketOpenError = error => ({
  type: WS_OPEN_FAIL,
  error
});
exports.websocketOpenError = websocketOpenError;
const WS_CLOSED = exports.WS_CLOSED = 'WS_CLOSED';
const websocketClosed = reason => ({
  type: WS_CLOSED,
  payload: reason
});
exports.websocketClosed = websocketClosed;
const WS_MSG_RECEIVED = exports.WS_MSG_RECEIVED = 'WS_MSG_RECEIVED';
const WS_MSG_SEND = exports.WS_MSG_SEND = 'WS_MSG_SEND';
const WS_MSG_PROCEED_ERROR = exports.WS_MSG_PROCEED_ERROR = 'WS_MSG_PROCEED_ERROR';
const WS_NEW_NOTIFICATION = exports.WS_NEW_NOTIFICATION = 'WS_NEW_NOTIFICATION';
const websocketMessageReceived = data => ({
  type: WS_MSG_RECEIVED,
  payload: data
});
exports.websocketMessageReceived = websocketMessageReceived;
const websocketMessageSend = details => ({
  type: WS_MSG_SEND,
  payload: details
});
exports.websocketMessageSend = websocketMessageSend;
const websocketMessageProceedError = error => ({
  type: WS_MSG_PROCEED_ERROR,
  payload: error
});
exports.websocketMessageProceedError = websocketMessageProceedError;
const websocketNewNotification = details => ({
  type: WS_NEW_NOTIFICATION,
  payload: details
});
exports.websocketNewNotification = websocketNewNotification;
const UA_OPEN_PENDING = exports.UA_OPEN_PENDING = 'UA_OPEN_PENDING';
const UA_OPEN_SUCCESS = exports.UA_OPEN_SUCCESS = 'UA_OPEN_SUCCESS';
const UA_MSG_SEND = exports.UA_MSG_SEND = 'UA_MSG_SEND';
const UA_CLOSED = exports.UA_CLOSED = 'UA_CLOSED';
const usageAnalyticsOpenPending = (hostname, protocol, path, trackLogin) => ({
  type: UA_OPEN_PENDING,
  payload: {
    hostname,
    protocol,
    path,
    trackLogin
  }
});
exports.usageAnalyticsOpenPending = usageAnalyticsOpenPending;
const usageAnalyticsOpenSuccess = () => ({
  type: UA_OPEN_SUCCESS
});
exports.usageAnalyticsOpenSuccess = usageAnalyticsOpenSuccess;
const usageAnalyticsSendMessage = (module, eventType, eventName, url, semantics) => {
  const browserInfo = (0, _browser.getBrowserInfo)();
  return {
    type: UA_MSG_SEND,
    payload: {
      module,
      event_type: eventType,
      event_name: eventName,
      url,
      host: window.location.host,
      hash: window.location.hash,
      query: window.location.search,
      browser: browserInfo.name,
      browser_version: browserInfo.version,
      os: browserInfo.os,
      os_version: browserInfo.osVersion,
      is_mobile: browserInfo.platform === 'mobile' || browserInfo.platform === 'tablet',
      screen_resolution: browserInfo.resolution,
      semantics
    }
  };
};
exports.usageAnalyticsSendMessage = usageAnalyticsSendMessage;
const closeUsageAnalytics = reason => ({
  type: UA_CLOSED,
  payload: reason
});
exports.closeUsageAnalytics = closeUsageAnalytics;
const SET_TOAST = exports.SET_TOAST = 'SET_TOAST';
const setToast = (payload, meta) => ({
  type: SET_TOAST,
  payload,
  meta
});
exports.setToast = setToast;
const SHOW_TOAST = exports.SHOW_TOAST = 'SHOW_TOAST';
const CLEAR_TOAST = exports.CLEAR_TOAST = 'CLEAR_TOAST';
const showToast = payload => ({
  type: SHOW_TOAST,
  payload
});
exports.showToast = showToast;
const clearToast = (payload, meta) => ({
  type: CLEAR_TOAST,
  payload,
  meta
});
exports.clearToast = clearToast;
const SET_SNACK = exports.SET_SNACK = 'SET_SNACK';
const CLEAR_SNACK = exports.CLEAR_SNACK = 'CLEAR_SNACK';
const CHANGE_SNACK = exports.CHANGE_SNACK = 'CHANGE_SNACK';
const setSnack = snack => ({
  type: SET_SNACK,
  payload: snack
});
exports.setSnack = setSnack;
const clearSnack = snack => ({
  type: CLEAR_SNACK,
  payload: snack
});
exports.clearSnack = clearSnack;
const UPDATE_SAGA_CONTEXT = exports.UPDATE_SAGA_CONTEXT = 'UPDATE_SAGA_CONTEXT';
const updateSagaContext = (config, locale) => ({
  type: UPDATE_SAGA_CONTEXT,
  payload: {
    config,
    locale
  }
});
exports.updateSagaContext = updateSagaContext;
const SHOW_BURGER_MENU = exports.SHOW_BURGER_MENU = 'SHOW_BURGER_MENU';
const showBurgerMenu = (show = true, id) => ({
  type: SHOW_BURGER_MENU,
  payload: {
    [id]: show
  }
});
exports.showBurgerMenu = showBurgerMenu;
const HEAP_LOAD_RESULT = exports.HEAP_LOAD_RESULT = 'HEAP_LOAD_(?!PENDING)';
const HEAP_LOAD_SUCCESS = exports.HEAP_LOAD_SUCCESS = 'HEAP_LOAD_SUCCESS';
const HEAP_LOAD_ERROR = exports.HEAP_LOAD_ERROR = 'HEAP_LOAD_ERROR';
const DYNATRACE_LOAD_RESULT = exports.DYNATRACE_LOAD_RESULT = 'DYNATRACE_LOAD_(?!PENDING)';
const DYNATRACE_LOAD_SUCCESS = exports.DYNATRACE_LOAD_SUCCESS = 'DYNATRACE_LOAD_SUCCESS';
const DYNATRACE_LOAD_ERROR = exports.DYNATRACE_LOAD_ERROR = 'DYNATRACE_LOAD_ERROR';
const GET_APP_CONFIG_RESULT = exports.GET_APP_CONFIG_RESULT = 'GET_APP_CONFIG_(?!PENDING)';
const TRACK_USER_IDENTITY = exports.TRACK_USER_IDENTITY = 'TRACK_USER_IDENTITY';
const dynatraceLoadSuccess = () => ({
  type: DYNATRACE_LOAD_SUCCESS
});
exports.dynatraceLoadSuccess = dynatraceLoadSuccess;
const dynatraceLoadError = () => ({
  type: DYNATRACE_LOAD_SUCCESS
});
exports.dynatraceLoadError = dynatraceLoadError;
const heapLoadError = () => ({
  type: HEAP_LOAD_ERROR
});
exports.heapLoadError = heapLoadError;
const heapLoadSuccess = () => ({
  type: HEAP_LOAD_SUCCESS
});
exports.heapLoadSuccess = heapLoadSuccess;